module.exports = __webpack_public_path__ + "img/lesion.2a5c32e4.svg";